import { render } from "./Appv2.vue?vue&type=template&id=8506726c&scoped=true"
import script from "./Appv2.vue?vue&type=script&lang=js"
export * from "./Appv2.vue?vue&type=script&lang=js"

import "./Appv2.vue?vue&type=style&index=0&id=8506726c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8506726c"]])

export default __exports__